import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { SearchBranch } from '../../../external/AggregationApi';
import { actions } from '../../modules/Actions';

export const initialSearchBranchNextActionState: { [key: string]: SearchBranch } = {};

export const searchBranchNextActionReducer = reducerWithInitialState(initialSearchBranchNextActionState).case(
  actions.updateSearchBranch.action,
  (state: { [key: string]: SearchBranch }, payload: { [key: string]: SearchBranch }) => {
    return {
      ...state,
      ...payload,
    };
  }
);
